
import XDialog from 'vux/src/components/x-dialog/index.vue'


export default {
components: { XDialog },
data() {
return {};
},

props: {
isShow: {
type: Boolean,
required: false,
default: false
},
listType: {
type: Boolean,
required: false,
default: false
},
listData: {
type: [Boolean, Array],
required: false
},
title: {
type: String,
required: false
},
message: {
type: String,
required: true
},
subMessage: {
type: String,
required: false
},
cancelText: {
type: String,
required: false,
default: ""
},
confirmText: {
type: String,
required: false,
default: ""
}
},
methods: {

cancelBtn() {
this.$emit("onCancel", {});
},

confirmBtn() {
this.$emit("onConfirm", {});
},
clickMenuList(id) {
this.$emit("onSelectList", id);
}
},
mounted() {},
computed: {
showDialog: function() {
return this.isShow;
}
}
};



// WEBPACK FOOTER //
// ./src/components/dialog.vue